import { map, Observable, take, tap } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { ContactUsSubject, ContactUsSubjectSaveResponse, NotifyType } from '@admin/containers/mojo-system-settings/sections/contact-us-subject/contact_us_subject-types';

@Injectable({
  providedIn: 'root'
})
export class ContactUsSubjectEditorFacadeService {

  constructor(
    private readonly urlProvider: UrlBuilderService,
    private readonly http: HttpClient
  ) {
  }

  loadSubjects() {
    const url = this.urlProvider.getUrl('contact-us-subjects/all');
    return this.http.get<ContactUsSubject[]>(url);
  }

  loadNotifyTypes() {
    const url = this.urlProvider.getUrl('contact-us-subjects/notify-types');
    return this.http.get<NotifyType[]>(url);
  }
  
  saveSubjects(subjects: ContactUsSubject[]): Observable<ContactUsSubjectSaveResponse> {
    const url = this.urlProvider.getUrl('contact-us-subjects');
    return this.http.post<ContactUsSubjectSaveResponse>(url, subjects).pipe(take(1), tap(() => this.loadSubjects()));
  }

}
